import classNames from "classnames";
import React from "react";

interface Props {
  percentage: number
  small?: boolean
}

export const ProgressRing = ({ percentage, small }: Props) => {
  const complete = percentage === 100;

  return <div className={classNames("progress-ring inline-flex flex-noshrink", { "progress-ring-small": small })}>
    <svg className={classNames({ s1_green: complete })} width="100%" height="100%" viewBox="0 0 114.5 114.5" fill="none" stroke="currentColor" strokeWidth={8} strokeLinecap="round">
      <circle cx="57.25" cy="57.25" r="52" pathLength={100} strokeOpacity={complete ? 1 : 0.3} />
      {percentage > 0 && <circle cx="57.25" cy="57.25" r="52" pathLength={100} strokeDasharray={`${percentage} 100`} transform="rotate(-90 57.25 57.25)" />}
    </svg>
    <div className={classNames("progress-ring-text flex-column align-center justify-center", { big_text: !small })}>
      {percentage}%
    </div>
  </div>;
};
